// Port of api/fuel/app/classes/controller/api/monty/listing/edition/create.php
import DB from 'offline/db'
import ListingComment from 'offline/model/listing/comment'
import {
	LIST_TYPE_AUTOMATED,
	createEdition,
	currentEdition,
	currentUserId,
	loadOwnedListing,
	parseGameIndex,
	persist,
	unauthorised
} from '../shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var current = null
	var edition = null
	var comments = []
	var i = 0

	if (!userId) return unauthorised()
	if (!listing || listing.get_template() || listing.get_type() === LIST_TYPE_AUTOMATED) return unauthorised()

	current = currentEdition(listing)
	if (!current) return Promise.reject({ error: 120, offline: true })

	edition = createEdition(
		listing,
		Math.floor(Date.now() / 1000),
		true,
		parseGameIndex(current.get_index_games())
	)

	if (params.data && params.data.comments) {
		comments = ListingComment.collection({
			where: [
				['list_edition_id', '=', current.get_id()]
			]
		})

		for (i = 0; i < comments.length; i++) {
			DB.run('INSERT INTO list_comment (list_id, list_edition_id, game_id, list_comment_date, list_comment_text) VALUES (?, ?, ?, ?, ?)', [
				comments[i].get_list_id(),
				edition.get_id(),
				comments[i].get_game_id(),
				Math.floor(Date.now() / 1000),
				comments[i].get_text()
			])
		}
	}

	return persist(edition.to_array())
}
